import React, { useEffect, useState } from 'react';
import Presentation from './presentation';
import logo from '../assets/app_icon.png';
import Resume from './resume';
import ConfigureUser from '../pages/configure_user';
import ChangeRates from './change_rates';
import PaymentMethods from './payment_methods';
import PushNotifications from './push_notifications';
import CloseSession from './close_session';
import ListUsers from './list_users';
import PromotionCode from './promotion_code';
import CarTypes from './car_types';

interface MenuItem {
  name: string,
  view: object,
  icon: string,
}
interface props {
  onView(view: object): void
}
const Menu: React.FC<props> = (props: props) => {
  const [selected, setSelected] = useState("Inicio");

  const items: MenuItem[] = [
    {
      name: "Inicio",
      view: <Presentation />,
      icon: "fas fa-home"
    },
    {
      name: "Resumen del Día",
      view: <Resume />,
      icon: "fas fa-file"
    },
    {
      name: "Codigos de Promocion",
      view: <PromotionCode />,
      icon: "fas fa-code",
    },
    {
      name: "Tipos de Vehiculos",
      view: <CarTypes />,
      icon: "fas fa-car"
    },
    {
      name: "Configurar Usuario",
      view: <ConfigureUser />,
      icon: "fas fa-cog"
    },
    {
      name: "Listado de Usuarios",
      view: <ListUsers />,
      icon: "fas fa-list"
    },
    {
      name: "Ubicaciones y Tarifas",
      view: <ChangeRates />,
      icon: "fas fa-map-pin"
    },
    {
      name: "Metodos de Pago",
      view: <PaymentMethods />,
      icon: "fas fa-money-bill"
    },
    {
      name: "Push Notifications",
      view: <PushNotifications />,
      icon: "fas fa-bell"
    },
    {
      name: "Salir",
      view: <CloseSession />,
      icon: "fas fa-times"
    }
  ];

  useEffect(() => {
    props.onView(<Presentation />);
  }, []);

  return (
    <aside className="menu">
      <section className="menu-header">
        <img src={logo} alt="" />
        <div>
        <h1>DXPress</h1>
        <h3>Panel Administrativo</h3>
        </div>
      </section>
      <ul className="menu-list">
        {
          items.map(item => {
            const isSelected = (item.name === selected);

            return (
              <li
                key={Math.random()}
                className={isSelected ? "menu-item-selected" : "menu-item-no-selected"}
                onClick={() => {
                setSelected(item.name);
                props.onView(item.view);
              }}>
                <a>
                  <span className="icon">
                    <i className={item.icon}></i>
                  </span>
                  {item.name}
                </a>
              </li>
            );
          })
        }
      </ul>
    </aside>
  );
};

export default Menu;